import { Component, OnInit, Renderer2 } from '@angular/core';
import * as qs from 'qs';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';
import { RestService } from './services/rest.service';

@Component({
  selector: 'app-root',
  // template: `
  //   <ng-progress></ng-progress>
  //   <router-outlet></router-outlet>
  // `,
  template: `
    <router-outlet></router-outlet>
    <am-toaster></am-toaster>
  `,
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private authService: AuthService,
    private restService: RestService,
    private swPush: SwPush,
    private swUpdate: SwUpdate,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm('New version available. Load New Version?')) {
          window.location.reload();
        }
      });
    }
    // set page title from router data variable
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data),
      )
      .subscribe(event => this.titleService.setTitle('InsurEco Wallet | ' + event['title']));
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }
}
